import React from 'react';

// Clean typographic logo for LayerSeek - Montserrat Bold
const LayerSeekLogo = ({ size = 'default' }) => {
  const sizes = {
    small: 'text-lg',
    default: 'text-xl',
    large: 'text-2xl'
  };

  const s = sizes[size] || sizes.default;

  return (
    <div className="flex items-baseline" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <span className={`${s} font-bold tracking-tight text-white`}>
        Layer
      </span>
      <span className={`${s} font-bold tracking-tight text-[var(--accent-primary)]`}>
        Seek
      </span>
    </div>
  );
};

export default LayerSeekLogo;
